import React, { useState } from 'react';

const SelectCompany = ({ companies, onSelectCompany }) => {
  const [selectedCompanyId, setSelectedCompanyId] = useState('');

  const handleCompanySelect = (e) => {
    const companyId = e.target.value;
    const company = companies.find(c => c.id_company === parseInt(companyId, 10));
    setSelectedCompanyId(companyId);
    onSelectCompany(company);
  };

  return (
    <div>
      <h1>Seleccione la Empresa</h1>
      <select onChange={handleCompanySelect} value={selectedCompanyId}>
        <option value="" disabled>Selecciona una empresa</option>
        {companies.map((company) => (
          <option key={company.id_company} value={company.id_company}>
            {company.name}
          </option>
        ))}
      </select>
      <button onClick={() => onSelectCompany(selectedCompanyId)}>Continuar</button>
    </div>
  );
};

export default SelectCompany;
